var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.crossSell.length
    ? _c(
        "Collapsible",
        {
          staticClass: "sidebar-cart__crosssell",
          attrs: { "initial-open": true }
        },
        [
          _c("template", { slot: "trigger" }, [
            _c("h3", { staticClass: "sidebar-cart__crosssell-title" }, [
              _c("span", {
                staticClass: "sidebar-cart__crosssell-title-text",
                domProps: { innerHTML: _vm._s(_vm.$t("cart.crossSell.title")) }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "sidebar-cart__crosssell-title-count",
                domProps: { innerHTML: _vm._s(_vm.crossSell.length) }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "sidebar-cart__crosssell-items" },
            _vm._l(_vm.crossSell, function(product) {
              return _c(
                "li",
                {
                  key: product.code,
                  staticClass: "sidebar-cart__crosssell-item"
                },
                [
                  product.image
                    ? _c(
                        "figure",
                        {
                          staticClass:
                            "sidebar-cart__crosssell-item-image-wrapper"
                        },
                        [
                          _c("img", {
                            staticClass:
                              "sidebar-cart__crosssell-item-image-element",
                            attrs: {
                              src: product.image,
                              alt: product.name,
                              loading: "lazy"
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sidebar-cart__crosssell-item-content",
                      class: {
                        "sidebar-cart__crosssell-item-content--configurable":
                          product.isConfigurable
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "sidebar-cart__crosssell-item-name",
                        domProps: { innerHTML: _vm._s(product.name) }
                      }),
                      _vm._v(" "),
                      product.isConfigurable
                        ? _c("Button", {
                            staticClass:
                              "sidebar-cart__crosssell-item-configure-button",
                            attrs: {
                              level: "outline",
                              type: "button",
                              text: _vm.$t("shoplist.product.configButton"),
                              disabled: _vm.lockedProducts[product.code],
                              tiny: ""
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.onConfig(product)
                              }
                            }
                          })
                        : _c(
                            "button",
                            {
                              staticClass:
                                "sidebar-cart__crosssell-item-cart-button",
                              attrs: {
                                disabled: _vm.lockedProducts[product.code]
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onCart(product)
                                }
                              }
                            },
                            [_c("SVGBag")],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sidebar-cart__crosssell-item-price" },
                        [
                          _vm.originalPrice(product)
                            ? _c("strike", {
                                staticClass:
                                  "sidebar-cart__crosssell-item-price-old",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$options.filters.fwgpricecent(
                                      _vm.originalPrice(product),
                                      "short"
                                    )
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", {
                            staticClass:
                              "sidebar-cart__crosssell-item-price-current",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.fwgpricecent(
                                  _vm.price(product),
                                  "short"
                                )
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }